var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup noselect"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Termín obhliadky")]), _c('div', {
    staticClass: "w-button saveformBtn"
  }, [_vm._v("Uložiť")])]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "podnikamOd"
    }
  }, [_vm._v("Termín obhliadky")]), _c('input', {
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "datetime-local",
      "min": _vm.todayLong,
      "maxlength": "256",
      "name": "podnikamOd",
      "data-name": "podnikamOd",
      "id": "podnikamOd",
      "required": ""
    }
  })]), _vm._m(0)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "sprava"
    }
  }, [_vm._v("Správa pre klienta")]), _c('textarea', {
    staticClass: "text-input w-input date-input",
    attrs: {
      "id": "sprava",
      "required": ""
    }
  })]);

}]

export { render, staticRenderFns }